import React, { FC, PropsWithChildren } from 'react';

export const isSSR = typeof window === 'undefined';

type SkipSSRProps = Required<PropsWithChildren>;

const SkipSSR: FC<SkipSSRProps> = (props) => {
  if (isSSR) {
    return null;
  }

  return <>{props.children}</>;
};

export default SkipSSR;
